import React, {useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import {packagingTypes} from "../../../../_data/mydata/packagingTypes";
import {quickClone} from "../../../../_helpers/commonFunctions";
import Dropdown from "../../Dropdown";
import Input from "../../../common/Input";
import AccountingBox from "../../AccountingBox";

const PackingsDeclarations = ({packingsDeclarations, callbackFunction, viewMode = false, mdWidth = 3}) => {
    const defaultNew = {
        packagingType: "1",
        quantity: 1,
        otherPackagingTypeTitle: "",
    }
    const [showNew, setShowNew] = useState(false);
    const [newObject, setNewObject] = useState({...defaultNew});

    const [showEdit, setShowEdit] = useState(false);
    const [editIndex, setEditIndex] = useState(0);
    const [editObject, setEditObject] = useState(null);

    const onNew = (newObj) => {
        callbackFunction([...(packingsDeclarations || []), newObj]);
        setShowNew(false);
        setNewObject({...defaultNew});
    }

    const onEdit = (index, editObj) => {
        const cloneThem = quickClone(packingsDeclarations || []);
        cloneThem[index] = editObj;
        callbackFunction(cloneThem);
        setShowEdit(false);
        setEditIndex(0);
        setEditObject(null);
    }

    const onDelete = (index) => {
        const cloneThem = quickClone(packingsDeclarations || []);
        cloneThem.splice(index, 1);
        callbackFunction(cloneThem);
        setShowEdit(false);
        setEditIndex(0);
        setEditObject(null);
    }

    return (
        <React.Fragment>
            {!viewMode && <Button size={"sm"} className={"mb-2"} onClick={() => setShowNew(true)}>+ Προσθήκη συσκευασίας</Button>}
            <Row>
                {packingsDeclarations && packingsDeclarations.map((pd, idx) => (
                    <Col md={mdWidth} idx={`pd-${idx}`} className={"mb-2"}>
                        <div className={`subscription-box ${!viewMode ? "subscription-box-permission" : ""}`} onClick={() => {
                            if (viewMode) return;

                            setShowEdit(true);
                            setEditIndex(idx);
                            setEditObject(pd);
                        }}>
                            <div style={{margin: "10px"}}>
                                <span style={{fontWeight: "600"}}>Είδος Συσκευασίας: </span>{packagingTypes.find((el) => String(el.value) === String(pd.packagingType)).label}<br/>
                                {(pd.otherPackagingTypeTitle && pd.packagingType === "6") && (
                                    <React.Fragment>
                                        <span style={{fontWeight: "600"}}>Τίτλος για Λοιπά Είδη Συσκευασίας: </span>{pd.otherPackagingTypeTitle}<br/>
                                    </React.Fragment>
                                )}
                                <span style={{fontWeight: "600"}}>Ποσότητα: </span> {pd.quantity}<br/>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>

            <Modal show={showNew} onHide={() => setShowNew(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Προσθήκη Συσκευασίας</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Dropdown
                        name={"packagingType"}
                        label={"Είδος Συσκευασίας"}
                        className={"mb-2"}
                        options={packagingTypes}
                        defaultValue={packagingTypes.find((el) => el.value === newObject.packagingType)}
                        key={Math.random()}
                        onChange={(e) => {
                            setNewObject({...newObject, packagingType: e.value});
                        }}
                    />
                    {newObject.packagingType === "6" && (
                        <Input
                            name={"otherPackagingTypeTitle"}
                            label={"Τίτλος για Λοιπά Είδη Συσκευασίας"}
                            value={newObject.otherPackagingTypeTitle}
                            charLimit={150}
                            className={"mb-2"}
                            onChange={(e) => {
                                setNewObject({...newObject, otherPackagingTypeTitle: e.target.value});
                            }}
                        />
                    )}
                    <label>Ποσότητα</label>
                    <AccountingBox
                        name={"quantity"}
                        key={newObject.quantity}
                        defaultValue={newObject.quantity}
                        suffix={"nosuffix"}
                        onBlur={(e) => {
                            setNewObject({...newObject, quantity: +e.target.value});
                        }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowNew(false)}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => onNew(newObject)}>
                        Προσθήκη
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showEdit} onHide={() => setShowEdit(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Επεξεργασία Συσκευασίας</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {editObject !== null && (
                        <React.Fragment>
                            <Dropdown
                                name={"packagingType"}
                                label={"Είδος Συσκευασίας"}
                                className={"mb-2"}
                                options={packagingTypes}
                                defaultValue={packagingTypes.find((el) => el.value === editObject.packagingType)}
                                key={editObject.packagingType}
                                onChange={(e) => {
                                    setEditObject({...editObject, packagingType: e.value});
                                }}
                            />
                            {editObject.packagingType === "6" && (
                                <Input
                                    name={"otherPackagingTypeTitle"}
                                    label={"Τίτλος για Λοιπά Είδη Συσκευασίας"}
                                    value={editObject.otherPackagingTypeTitle}
                                    charLimit={150}
                                    className={"mb-2"}
                                    onChange={(e) => {
                                        setEditObject({...editObject, otherPackagingTypeTitle: e.target.value});
                                    }}
                                />
                            )}
                            <label>Ποσότητα</label>
                            <AccountingBox
                                name={"quantity"}
                                key={editObject.quantity}
                                defaultValue={editObject.quantity}
                                suffix={"nosuffix"}
                                onBlur={(e) => {
                                    setEditObject({...editObject, quantity: +e.target.value});
                                }}
                            />
                        </React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-danger" onClick={() => onDelete(editIndex)}>
                        Διαγραφή
                    </Button>
                    <Button variant="primary" onClick={() => onEdit(editIndex, editObject)}>
                        Αποθήκευση
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default PackingsDeclarations;
